import { AccountBindTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

// This file includes different page types that all belong to the same flow (Account Bind)

const AccountBindTrackingSchema: Record<AccountBindTrackingPoint, string> = {
  [AccountBindTrackingPoint.AccountBindingPageView]:
    '1368df3e-be3a-4821-9b29-b0c9cd5367a2',
  [AccountBindTrackingPoint.AccountBindingContinueButtonClick]:
    '764dc75f-0082-47ea-b0e9-c5424982e6c3',
  [AccountBindTrackingPoint.AccountBindingLinkingFailedView]: '',
  [AccountBindTrackingPoint.AccountBindingLinkingFailedContactUsClick]: '',
  [AccountBindTrackingPoint.AccountBindingLinkingFailedOkButtonClick]: '',
  [AccountBindTrackingPoint.ReclaimPhoneClick]:
    'aaf8b380-7546-4575-9eb5-213b6da41b1f',
  [AccountBindTrackingPoint.ReclaimPhoneSuccessAction]:
    '0a233df5-bf9e-4cbe-9608-0a43b1a45458',
  [AccountBindTrackingPoint.ReclaimPhoneFailedPageView]:
    '3954ac98-0cc9-48d2-b02c-dc6d811c032b',
  [AccountBindTrackingPoint.ReclaimPhoneFailedHelpButtonClick]:
    '2c60959b-6723-4bee-b1b3-b64696235632',
  [AccountBindTrackingPoint.ReclaimPhoneFailedContactCustomerServiceClick]:
    '1feb197c-e3cd-4123-b537-eaf99907a3dd',
  [AccountBindTrackingPoint.ReclaimPhoneFailedGoHelpCenterClick]:
    '9dab90b4-a345-427b-bdce-d6aef161b935',
  [AccountBindTrackingPoint.CreateAccountPageView]:
    'f5d9f0bc-fbe4-42f1-9d6e-4800bc1e9cd8',
  [AccountBindTrackingPoint.CreateAccountContinueButtonClick]:
    'edbbf731-fc68-4a63-a836-c8227de13acf',
  [AccountBindTrackingPoint.SetPasswordPageView]:
    '0c40f52e-b308-4ecf-b0ee-8840798d9005',
  [AccountBindTrackingPoint.SetPasswordConfirmButtonClick]:
    '2f433f38-5703-48d0-a30b-fec101ee8a95',
  [AccountBindTrackingPoint.SetPasswordHelpButtonClick]: '',
  [AccountBindTrackingPoint.SetPasswordSuccessAction]: '',
};

export const getAccountBindAccountBindingPageTypeAndSchema = (
  trackingPoint: AccountBindTrackingPoint
) => {
  return {
    page_type: PageType.AccountBindAccountBindingPage,
    schema: AccountBindTrackingSchema[trackingPoint],
  };
};

export const getAccountBindCreateAccountPageTypeAndSchema = (
  trackingPoint: AccountBindTrackingPoint
) => {
  return {
    page_type: PageType.AccountBindCreateAccountPage,
    schema: AccountBindTrackingSchema[trackingPoint],
  };
};

export const getAccountBindReclaimFailurePageTypeAndSchema = (
  trackingPoint: AccountBindTrackingPoint
) => {
  return {
    page_type: PageType.AccountBindReclaimFailurePage,
    schema: AccountBindTrackingSchema[trackingPoint],
  };
};

export const getAccountBindSetPasswordPageTypeAndSchema = (
  trackingPoint: AccountBindTrackingPoint
) => {
  return {
    page_type: PageType.AccountBindSetPasswordPage,
    schema: AccountBindTrackingSchema[trackingPoint],
  };
};
